import React from 'react';
import { useNavigate } from 'react-router-dom';

import { SvgCardType } from '../../components/svg-card/svg-card-types';
import { RadioAlternativ } from '../../sporsmalsflyt/reducer/sporsmalsflyt-types';
import { Skademeldingstype } from '../../types/generated-types';
import { skadeUrlFromSkadetype } from '../../urler';
import { GruppeLandingsside } from '../gruppe-landingsside';
import { KategoriSvarId } from '../sporsmal-og-svar';

const alternativer: RadioAlternativ[] = [
    {
        id: KategoriSvarId.BatInnbrudd,
        tekst: KategoriSvarId.BatInnbrudd,
    },
    {
        id: KategoriSvarId.BatStjaletOgFunnet,
        tekst: KategoriSvarId.BatStjaletOgFunnet,
    },
    {
        id: KategoriSvarId.BatStjaletOgIkkeFunnet,
        tekst: KategoriSvarId.BatStjaletOgIkkeFunnet,
    },
];

export const TyveriEllerInnbrudd = () => {
    const navigate = useNavigate();

    const onNext = (svarId: KategoriSvarId) => {
        if (svarId === KategoriSvarId.BatInnbrudd) {
            navigate(skadeUrlFromSkadetype(Skademeldingstype.BatInnbrudd));
        } else if (svarId === KategoriSvarId.BatStjaletOgFunnet) {
            navigate(skadeUrlFromSkadetype(Skademeldingstype.BatStjaletOgFunnet));
        } else if (svarId === KategoriSvarId.BatStjaletOgIkkeFunnet) {
            navigate(skadeUrlFromSkadetype(Skademeldingstype.BatStjaletOgIkkeFunnet));
        }
    };

    const goback = () => navigate(-1);
    return (
        <GruppeLandingsside
            title="Tyveri eller innbrudd"
            onNext={onNext}
            navigateToParent={goback}
            alternativer={alternativer}
            svgCardType={SvgCardType.BaatSkade}
            kategoriId="bat-tyveri-innbrudd"
        />
    );
};
